import { SelectedTrip, VersionData } from "../../interfaces";
import { commonSlice, store } from "../../store";
import {
    getGoCancelPositions,
    resetGoCancelPositions,
} from "../shift_monitoring/trips/trip_reports";
import { api } from "./make_api";

export const getVersions = async (): Promise<VersionData> => {
    const client = api.getCommonAPI();
    const vi = (await client.getversions()) as VersionData;

    store.dispatch(commonSlice.actions.setVersions(vi));
    return vi;
};

export const selectTrip = async (trip: SelectedTrip | null): Promise<void> => {
    await store.dispatch(commonSlice.actions.setSelectedTrip(trip));
    await resetGoCancelPositions();
    if (trip) {
        await getGoCancelPositions(trip.loginSessionId, trip.tripSessionId);
    }
};

export const setSnackbarToggled = async (state: boolean): Promise<void> => {
    await store.dispatch(commonSlice.actions.setSnackbarToggled(state));
};

export const setSnackbarMsg = async (msg: string): Promise<void> => {
    await store.dispatch(commonSlice.actions.setSnackbarMsg(msg));
};

export const setCanUseMapNeighbors = async (val: boolean): Promise<void> => {
    await store.dispatch(commonSlice.actions.setCanUseMapNeighbors(val));
};
